function Footer() {

  return <div id="footer">
    This site developed by Furkan Baytekin using React for educational purposes. By using this service, <u>you do not accept</u> terms of service.
  </div>
}

export default Footer
